import { Component, OnInit } from '@angular/core';

import { AnimationDisplayNone } from '@ib-shared/animations/in-opacity-300ms.anim';
import { INVESTOR_SIGN_UP_STEPS } from 'credebt-shared';
import { map, Observable, tap } from 'rxjs';

import { ISignUpStep } from '../../interfaces/sign-up-step.intf';
import { SignUpFacadeService } from '../../services/sign-up-facade.service';
@Component({
  selector: 'ib-sign-up-steps',
  templateUrl: './sign-up-steps.component.html',
  styleUrls: ['./sign-up-steps.component.scss'],
  animations: [AnimationDisplayNone],
})
export class SignUpStepsComponent implements OnInit {
  public steps$: Observable<Array<ISignUpStep>>;
  public currStep$: Observable<ISignUpStep>;
  public currStepIndex$: Observable<number>;
  public readonly STEPS = INVESTOR_SIGN_UP_STEPS;
  public stepsAmount: number;

  constructor(private signUpFacadeS: SignUpFacadeService) {}

  ngOnInit(): void {
    this.currStepIndex$ = this.signUpFacadeS.selectCurrStepIndex();
    this.steps$ = this.signUpFacadeS
      .selectSteps()
      .pipe(tap(r => (this.stepsAmount = r.length)));
    this.currStep$ = this.signUpFacadeS.selectCurrStepIndex().pipe(
      map(order => {
        return this.signUpFacadeS.steps.find(step => step.index === order);
      }),
    );
  }

  setStep(step: ISignUpStep): void {
    this.signUpFacadeS.setStepIndex(step.index);
  }

  setNextStep(): void {
    this.signUpFacadeS.setNextStep();
  }

  setPrevStep(): void {
    this.signUpFacadeS.setPrevStep();
  }

  clearAll(): void {
    this.signUpFacadeS.clearAllSteps();
  }

  finish(): void {
    this.signUpFacadeS.finish();
  }
}
